<template>
    <button class="absolute right-0 bottom-0 round-button">
        <span>
            <slot></slot>
        </span>
    </button>
</template>

<style scoped>
    .round-button {
        min-width: 60px;
        max-width:120px;
        text-decoration: none;
        display: inline-block;
        outline: none;
        cursor: pointer;
        border-style: none;
        border-radius: 100%;
        overflow: none;
        text-align: center;
        padding:0;
    }

    .round-button:before {
        content:'';
        display:inline-block;;
        vertical-align:middle;
        padding-top:100%;
    }

    .round-button span {
        display:inline-block;
        vertical-align:middle;
        max-width:90%;
    }

    .round-button:active{
        @apply opacity-50;
    }
</style>

<script>
    export default {

    }
</script>